// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import '@/styles/main.scss';

import { createVuetify } from 'vuetify';
import type { ThemeDefinition } from 'vuetify'

const edReportsTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#007EAB',
    secondary: '#0A3E59',
    accent: '#D83F24',
    background: '#FFFFFF',
    surface: '#F2FAFC',
    error: '#D32F2F',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FF9800',
    textSecondary: '#0A3E59',
    
    'on-background': '#000000',
    'on-surface': '#000000',
    'on-primary': '#FFFFFF',
    'on-secondary': '#FFFFFF',
    'on-error': '#FFFFFF',
    'on-info': '#FFFFFF',
    'on-success': '#FFFFFF',
    'on-warning': '#000000',

    // Blue variations
    'darker-blue': '#041923',
    'dark-blue': '#0A3E59',
    'format-blue-2': '#557C90',
    'format-blue-3': '#90B9CE',
    'blue-border': '#0096CB33',
    'blue-border-transparent': 'rgba(0, 150, 204, 0.502)',
    'blue': '#0096cb',
    'blue-accessible-on-dark': '#00b0f0',
    'light-blue': '#ebf7fb',
    'light-blue-border': '#c6e3ed',
    'light-blue-pill': '#D2F4FF',
    'grey-blue': '#d9eff7',

    // Green variations
    'dark-green': '#637619',
    'green': '#9fbc28',
    'status-green': '#0B874D',
    'light-green': '#f0f5dd',
    'card-bg-green': '#ebf5f1',
    'card-border-green': '#b3d9c8',

    // Yellow variations
    'dark-yellow': '#916403',
    'yellow': '#f1a706',
    'light-yellow': '#fdf1d7',
    'status-yellow': '#CE8003',

    // Red variations
    'dark-red': '#b83a00',
    'red': '#f54e00',
    'light-red': '#fde3d6',
    'status-red': '#C72A4C',

    // Purple variations
    'purple': '#501041',
    'light-purple': '#af71a6',

    // Grayscale
    'black': '#000000',
    'tonal-black': '#02080c',
    'dark-grey': '#495965',
    'grey': '#666666',
    'light-grey': '#cccccc',
    'lighter-grey': '#d4d4d4',
    'lightest-grey': '#ededed',
    'meta-grey': '#6c8b9b',
    'white': '#ffffff',
    'shadow': 'rgba(0, 0, 0, 0.09098)',
    'grey-pill': '#DAE2E6',
    'grey-pill-transparent': 'rgba(73, 89, 101, 0.1)',
    'status-gray': '#d1d1d1',

    // Button
    'btn-gray': '#F2F2F2',

    // Border colors
    'border-light': 'rgba(0, 0, 0, 0.12)',
  },
};

// Create Vuetify instance
export default createVuetify({
  theme: {
    defaultTheme: 'edReportsTheme',
    themes: {
      edReportsTheme,
    }
  },
  defaults: {
    VCard: {
      color: 'white',
      elevation: 0,
      rounded: 3,
      class: 'custom-card-radius',
      style: 'border: 1px solid rgba(0, 0, 0, 0.12)',
    },
    VList: {
      rounded: 3,
    },
    VBtn: {
      variant: 'text',
      color: 'primary',
      class: 'text-none font-weight-regular',
      height: 40,
    },
    VIcon: {
      size: 'small',
      class: 'mr-2',
    },
    VContainer: {
      maxWidth: {
        xxl: '1296px'
      }
    },
    VAlert: {
      icon: false,
      variant: 'tonal',
      class: 'text-uppercase',
    },
  },
});

// Export theme colors for direct use in components
export const themeColors = edReportsTheme.colors;
